import React, { useState, forwardRef, useImperativeHandle } from 'react';
import ScaylorOrbB from '../assets/images/ScaylorOrbB.svg';
import ReactMarkdown from 'react-markdown';

const ScaylorSearchCard = forwardRef(({ selectedContextId, searchQuery }, ref) => {
  const [content, setContent] = useState('');

  const fetchLatestMessage = async () => {
    if (!selectedContextId) return Promise.resolve();

    const token = localStorage.getItem('token');
    if (!token) return Promise.resolve();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/messages/${selectedContextId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        const messages = await response.json();
        console.log('Messages API Response for ScaylorSearch:', messages);
        
        // Get the latest message's content
        const latestMessage = messages[messages.length - 1];
        if (latestMessage && latestMessage.content) {
          setContent(latestMessage.content);
        }
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  useImperativeHandle(ref, () => ({
    fetchLatestMessage
  }));

  if (!selectedContextId) return null;

  return (
    <div className="mt-8 mb-12 max-w-3xl mx-auto">
      {/* Display the search query */}
      {searchQuery && (
        <div className="mb-4 text-gray-600 font-medium">
          You searched for: "{searchQuery}"
        </div>
      )}
      
      {content && (
        <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200">
          <div className="relative z-10">
            <div className="flex items-center gap-2 mb-4">
              <img src={ScaylorOrbB} alt="Scaylor" className="w-6 h-6" />
              <span className="font-bold text-blue-900">SCAYLOR search</span>
            </div>
            <div className="text-gray-700 prose prose-sm max-w-none">
              <ReactMarkdown
                components={{
                  h1: ({node, ...props}) => <h1 className="text-2xl font-bold mb-4 mt-6" {...props} />,
                  h2: ({node, ...props}) => <h2 className="text-xl font-bold mb-3 mt-5" {...props} />,
                  h3: ({node, ...props}) => <h3 className="text-lg font-bold mb-2 mt-4" {...props} />,
                  p: ({node, ...props}) => <p className="mb-4" {...props} />,
                  ul: ({node, ...props}) => <ul className="list-disc pl-6 mb-4 space-y-2" {...props} />,
                  li: ({node, ...props}) => <li className="mb-1" {...props} />,
                  strong: ({node, ...props}) => <strong className="font-bold text-gray-900" {...props} />,
                  hr: ({node, ...props}) => <hr className="my-6 border-t border-gray-200" {...props} />,
                  em: ({node, ...props}) => <em className="italic text-gray-800" {...props} />
                }}
              >
                {content}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default ScaylorSearchCard; 